import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  add as addLayoutGroup
} from '../redux/layoutGroups'
import {
  addLayoutGroup as addLayoutGroupToLayout
} from '../redux/layouts'

export default function * requestAddLayoutGroup (action) {
  const { layoutId, name, position } = action.payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = yield optimisticPut([
    addLayoutGroup({
      key: `${layoutId}-${tempId}`,
      id: tempId,
      name: name,
      isBusy: true
    }),
    addLayoutGroupToLayout({
      layoutId,
      layoutGroupId: tempId,
      position
    })
  ])

  try {
    yield call(apiAction, 'AddLayoutGroup', {
      layoutId,
      name,
      position
    })
  } finally {
    yield optimisticAction.revert()
  }
}
